<!--营养状况统计-->
<template>
  <div>

    <el-card style="margin: 20px;">
      <el-form ref="form" size="small" label-width="70px">
        <el-form-item label="学校：">
          <ZxxSchool-select ref="schools" v-model="form.schoolId"></ZxxSchool-select>
        </el-form-item>
        <el-form-item label="年级：">
          <el-input v-model="form.grade"></el-input>
        </el-form-item>
        <el-form-item label="班级：">
          <el-input v-model="form.classRoomNo"></el-input>
        </el-form-item>
        <el-form-item label="性别：">
          <sex-select v-model="form.sex"></sex-select>
        </el-form-item>
        <el-form-item label="年度：">
          <year-select v-model="form.year"></year-select>
        </el-form-item>
        <el-col :xl="4" :lg="5">
          <el-form-item style="width: 100%;" label="统计类型：" label-width="100px">
            <statistical-type-select v-model="form.groupBy" :clearable="false"  @updateValue="search"></statistical-type-select>
          </el-form-item>
        </el-col>
        <div style="display: flex; margin-left: auto">
          <div>
            <el-button size="small" v-show="$hasPermission('nutrition.list')" type="primary" @click="search">查 询</el-button>
            <el-button size="small" v-show="$hasPermission('nutrition.export')" type="primary" @click="exportExcel">导 出</el-button>
            <el-button size="small" v-show="$hasPermission('nutrition.print')" type="primary" @click="printTable">打印当前页</el-button>
          </div>
        </div>
      </el-form>

    </el-card>
    <el-card style=" margin: 20px">
      <el-table
          id="exportTab"
          :data="formList2"
          v-loading="loading"
          border
          style="width: 100%"
      >
        <el-table-column
            :key="type"
            :label="type"
            prop="_id"
        >
          <template slot-scope="scope">
            <template v-if="form.groupBy === '$sex'">
              <div v-if="scope.row._id === 0">男</div>
              <div v-if="scope.row._id === 1">女</div>
              <div v-if="scope.row._id === '合计'">合计</div>
            </template>
            <template v-else>
              <div>{{ scope.row._id }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
            align="left"
            label="受检人数"
            prop="total"
        >
        </el-table-column>
        <el-table-column
            label="生长迟缓">
          <el-table-column
              label="人数"
              prop="r020Sum"
          >
          </el-table-column>
          <el-table-column
              label="率(%)"
              prop="r020Rate"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.r020Rate |percent }}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="轻度消瘦">
          <el-table-column
              label="人数"
              prop="r021Sum"
          >
          </el-table-column>
          <el-table-column
              label="率(%)"
              prop="r021Rate"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.r021Rate |percent }}</div>
            </template>
          </el-table-column>

        </el-table-column>
        <el-table-column
            label="中重度消瘦">
          <el-table-column
              label="人数"
              prop="r022Sum"

          >
          </el-table-column>
          <el-table-column
              label="率(%)"
              prop="r022Rate"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.r022Rate |percent }}</div>
            </template>
          </el-table-column>

        </el-table-column>
        <el-table-column
            label="体重偏低">
          <el-table-column
              label="人数"
              prop="r003Sum"
          >
          </el-table-column>
          <el-table-column
              label="率(%)"
              prop="r003Rate"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.r003Rate |percent }}</div>
            </template>
          </el-table-column>

        </el-table-column>


        <el-table-column
            label="超重">
          <el-table-column
              label="人数"
              prop="r004Sum"
          >
          </el-table-column>
          <el-table-column
              label="率(%)"
              prop="r004Rate"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.r004Rate |percent }}</div>
            </template>
          </el-table-column>

        </el-table-column>

        <el-table-column
            label="肥胖">
          <el-table-column
              label="人数"
              prop="r005Sum"
          >
          </el-table-column>
          <el-table-column
              label="率(%)"
              prop="r005Rate"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.r005Rate |percent }}</div>
            </template>
          </el-table-column>

        </el-table-column>



      </el-table>


    </el-card>
  </div>
</template>

<script>

import ZxxSchoolSelect from "@/components/ZxxSchoolSelect"
import gradeSelect from "@/components/gradeSelect"
import classRoomNoSelect from "@/components/classRoomNoSelect"
import sexSelect from "@/components/sexSelect"
import yearSelect from "@/components/yearSelect"
import statisticalTypeSelect from "@/components/statisticalTypeSelect"


import * as scriptApi from "@/api/gen/scriptApi"

export default {
  name: "nutrition",
  components: {
    ZxxSchoolSelect,
    statisticalTypeSelect,
    gradeSelect,
    classRoomNoSelect,
    sexSelect,
    yearSelect,

  },
  data() {
    return {
      form: {
        id: "",
        schoolId: "",
        schoolType: "",
        idNo: "",
        grade: "",
        classRoomNo: "",
        name: "",
        birthDate: "",
        age: "",
        sex: "",
        studentId: "",
        contact: "",
        nationalityCode: "",
        cxType: "",
        checkDate: "",
        year: "",
        result: "",
        advice: "",
        groupBy: ""
      },

      name: '',
      scriptName: '',
      formList: [],


      isEditShow: false,
      isUpdateDialog: false,
      current: {},
      model: "",
      options: "",
      loading: false
    }
  },
  computed: {
    type() {
      if (this.form.groupBy === '$age') {
        return '年龄(岁)'
      }
      if (this.form.groupBy === '$sex') {
        return '性别'
      }
      if (this.form.groupBy === '$grade') {
        return '年级'
      }
    },

    formList2(){
      var total= this._.sumBy(this.formList,'total')
      var  r003Sum=this._.sumBy(this.formList,'r003Sum')
      var  r004Sum=this._.sumBy(this.formList,'r004Sum')
      var r005Sum=this._.sumBy(this.formList,'r005Sum')
      var  r020Sum=this._.sumBy(this.formList,'r020Sum')
      var  r021Sum=this._.sumBy(this.formList,'r021Sum')
      var r022Sum=this._.sumBy(this.formList,'r022Sum')
      this.formList.push({
        "_id":'合计',
        total,
        r003Sum,
        r004Sum,
        r005Sum,
        r020Sum,
        r021Sum,
        r022Sum,
        r020Rate: total?r020Sum/total:0,
        r021Rate: total?r021Sum/total:0,
        r022Rate: total?r022Sum/total:0,
        r003Rate: total?r003Sum/total:0,
        r004Rate: total?r004Sum/total:0,
        r005Rate: total?r005Sum/total:0
        

      })
      return this.formList
    }

  },
  mounted() {


  },
  methods: {

    async search() {
      if(!this.form.schoolId){
        this.$message.warning('请选择学校')
        return
      }
      await this.scriptList()

    },


    async scriptList() {
      this.loading = true
      let clone = this._.cloneDeep(this.form)
      if (!clone.schoolId) {
        clone.schoolId = this.$refs.schools.getItems().map(item => item.id).join(',')
      }
      if(clone.sex){
        if(clone.sex=='男'){
          clone.sex =0;
        }else{
          clone.sex =1;
        }
      }

      this.formList = await scriptApi.execute({name: '全部统计.groovy', params: clone})

      this.formList = this._.chain(this.formList).sortBy(x => parseFloat(x._id)).value()
      this.$sortByGrade(this.formList)
      this.loading = false
    },

    exportExcel() {
      var sex =this.form.sex
      var grade =this.form.grade
      var classRoomNo =this.form.classRoomNo
      var query =[]
      var queryStr =""
      if(sex){
        query.push(sex)
      }
      if(grade){
        query.push(grade)
      }
      if(classRoomNo){
        query.push(classRoomNo)
      }
      if(query.length>0){
        queryStr = query.join("-")
      }
      if(queryStr){
        queryStr=queryStr+"-"
      }
      this.$exportToExcel(`${this.$store.getters.organizationName}-${this.form.year}-${queryStr}${this.$storage.getStorage('pageName')}-${this.$dateString(this.$now())}.xlsx`, '#exportTab',queryStr)
    },
    // exportExcel() {
    //   this.$exportToExcel(`${this.$store.getters.organizationName}-${this.form.year}-${this.$storage.getStorage('pageName')}-${this.$dateString(this.$now())}.xlsx`, '#exportTab')
    // },
    printTable() {

      this.$print('#exportTab')
    },

  }

}
</script>

<style scoped>
.el-card .el-form {
  display: flex;
  flex-wrap: wrap;

}

/deep/ .el-form-item {
  width: 13%;
}


/deep/ .el-table td,
/deep/ .el-table th {
  text-align: center;
}

/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border: 1px solid #EBEEF5 !important;
}

/deep/ .el-table--border th, /deep/ .el-table__fixed-right-patch {
  border: 1px solid #EBEEF5 !important;
}
</style>
